import { NotificationSwitcherComponent } from './switcher/notification-switcher.component';
import { NotificationSettingsAbout } from './about/notification-settings-about.component';

export const NotificationSettingsModule = angular.module('topbroker.settings.notification', [])

  .component('notificationSwitcher', NotificationSwitcherComponent)
  .component('notificationSettingsAbout', NotificationSettingsAbout)
  .name;
